// extracted by mini-css-extract-plugin
export var legendIndicator = "_ig-1";
export var legendRight = "_ig-0";